<template>
  <div v-if="length(pages) == 0" class="display-5 mt-4">
    {{ translations.actions.NO_RESULTS }}
  </div>
  <div v-else class="row pt-4">
    <div
      v-for="page in pages"
      :key="page.id"
      class="col col-6 col-lg-4"
      :style="{ order: page.kind_sequence }"
    >
      <div class="megamenu-section row-space markdown-compact">
        <a
          v-if="selected[page.id] || page.img"
          class="megamenu-preview rounded"
          data-track-event="menu_link"
          data-track-type="menu"
          :href="page.url"
          :style="{
            'background-image':
              'url(' +
              (selected[page.id] ? selected[page.id].img : page.img) +
              ')',
          }"
          :title="page.unicode"
          @click="close"
        />
        <a
          class="h6"
          data-track-event="menu_link"
          data-track-type="menu"
          :href="page.url"
          :title="page.unicode"
          @click="close"
        >
          <icon v-if="page.icon" :name="page.icon" />
          {{ page.unicode }}</a
        >
        <p
          v-if="length(page.descendants) == 0"
          class="small markdown"
          v-html="page.description"
        ></p>

        <div v-else class="d-flex flex-column">
          <a
            v-for="sub in truncate_links(page)"
            :key="sub.id"
            class="megamenu-link"
            data-track-event="menu_link"
            data-track-type="menu"
            :href="sub.url"
            :style="{ order: sub.kind_sequence }"
            :title="sub.unicode"
            @click="close"
            @mouseout="() => delete_property(selected, page.id)"
            @mouseover="() => set_property(selected, page.id, sub)"
            >{{ sub.unicode }}</a
          >
        </div>
        <a
          v-if="length(page.descendants) > expandSize"
          class="megamenu-expand"
          href="#"
          @click.prevent="toggle_expanded(page.id)"
        >
          {{
            is_expanded(page.id)
              ? translations.actions.HIDE
              : translations.actions.SHOW_ALL +
                " (" +
                length(page.descendants) +
                ")"
          }}
        </a>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { filter, length } from "@pdfking/rfunc"
import icon from "@pdfking/workflow/components/icon"
import make_translations from "@pdfking/workflow/utils/make_translations"
import delete_property from "@pdfking/workflow/vue/3/delete_property"
import set_property from "@pdfking/workflow/vue/3/set_property"
import close from "../../../mixins/close"
import state from "../../../state/main"

export default {
  components: {
    icon,
  },
  computed: {
    translations: () => make_translations("actions"),
  },
  data() {
    return {
      expanded: {},
      selected: {},
    }
  },
  methods: {
    delete_property,
    is_expanded(id: string) {
      return this.expanded[id]
    },
    length,

    set_property,
    toggle_expanded(id: string) {
      set_property(this.expanded, id, !this.expanded[id])

      if (this.expanded[id]) {
        state.track_event("menu_expand", "menu")
      }
    },
    truncate_links(page: any) {
      if (this.is_expanded(page.id)) {
        return page.descendants
      }

      return filter((_page: any, index: number) => index < this.expandSize, page.descendants)
    },
  },
  mixins: [close],
  props: {
    expandSize: {
      default: 6,
      type: Number,
    },
    pages: {
      default: () => [],
      type: Array,
    },
  },
}
</script>
